import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

export interface FormRowProps extends GridProps {
  itemsCount?: number
}

export const FormRow = ({ itemsCount: itemsCount = 2, children, sx, ...props }: FormRowProps) => {
  return (
    <Grid
      {...props}
      sx={{
        w: '100%',
        gridTemplateColumns: {
          base: '1fr',
          lg: `repeat(${itemsCount}, 1fr)`,
        },

        columnGap: { base: 8, lg: 16 },
        rowGap: 12,
        ...sx,
      }}
    >
      {children}
    </Grid >
  )
}
